import { render } from "./Ratings.vue?vue&type=template&id=16b33de2&ts=true"
import script from "./Ratings.vue?vue&type=script&lang=ts"
export * from "./Ratings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__